import React from "react";

import { SelectInput, InputProps } from "react-admin";
import {
  CUSTOMER_ADMINISTRATOR,
  SYSTEM_ADMINISTRATOR,
  WEBMAIL_SERVICE,
} from "../authProvider/roles";

const roleValues = [
  SYSTEM_ADMINISTRATOR,
  CUSTOMER_ADMINISTRATOR,
  WEBMAIL_SERVICE,
];

const RoleSelectInput = (props: InputProps) => {
  return (
    <SelectInput
      choices={roleValues.map((roleValue) => ({
        id: roleValue,
        name: `resources.Account.roles.${roleValue}`,
      }))}
      {...props}
    />
  );
};
export default RoleSelectInput;
